/* eslint-disable @typescript-eslint/member-ordering */

import { inject, Injectable, Signal, signal, WritableSignal } from '@angular/core';
import { Router } from '@angular/router';
import { SearchInputModel } from '@libs/shop/models';
import { PRODUCT_SEARCH_URL_FRAGMENTS} from '@libs/shared/models';

@Injectable({
  providedIn: 'root',
})
export class CepStateService {
  readonly #router: Router = inject(Router);

  readonly #footerVisible: WritableSignal<boolean> = signal(true);
  readonly #hideScannerFAB: WritableSignal<boolean> = signal(true);
  readonly #pageTitle: WritableSignal<string> = signal('');
  readonly #searchParams: WritableSignal<SearchInputModel> = signal<SearchInputModel>({
    page: 0,
    ipp: 36,
  });

  public readonly footerVisible: Signal<boolean> = this.#footerVisible.asReadonly();
  public readonly hideScannerFAB: Signal<boolean> = this.#hideScannerFAB.asReadonly();
  public readonly pageTitle: Signal<string> = this.#pageTitle.asReadonly();
  public readonly searchParams: Signal<SearchInputModel> = this.#searchParams.asReadonly();

  public setSearchParams(params: SearchInputModel): void {
    this.#searchParams.set(params);
  }

  public updateSearchParams(patch: Partial<SearchInputModel>): void {
    this.#searchParams.update((params: SearchInputModel) => ({ ...params, ...patch }));
  }

  public setPageTitle(title: string): void {
    this.#pageTitle.set(title);
  }

  public setHideScannerFAB(hidden: boolean): void {
    this.#hideScannerFAB.set(hidden);
  }

  public showFooter(): void {
    this.#footerVisible.set(true);
  }

  public hideFooter(): void {
    this.#footerVisible.set(false);
  }

  public async navigateToSearch(searchText: string): Promise<boolean> {
    return this.#router.navigate(['search'], {
      queryParams: {
        page: 0,
        q: searchText,
      },
    });
  }

  public getProductSearchParams(path: string): SearchInputModel | undefined {
    const isProductSearchPath: boolean = PRODUCT_SEARCH_URL_FRAGMENTS.some((fragment: string) => path.includes(fragment));

    return isProductSearchPath ? this.#searchParams() : undefined;
  }

  public getProductSearchTerm(path: string): string | null {
    return this.getProductSearchParams(path)?.q ?? null;
  }
}
